import * as React from "react"
const TacticIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        fill="none"
        {...props}
    >
        <mask
            id="a"
            width={24}
            height={24}
            x={0}
            y={0}
            maskUnits="userSpaceOnUse"
            style={{
                maskType: "alpha",
            }}
        >
            <path fill={props.fill || "#D9D9D9"} d="M0 0h24v24H0z" />
        </mask>
        <g mask="url(#a)">
            <path
                fill={props.fill || "#fff"}
                d="M16.4 21 15 19.6l1.575-1.6L15 16.425 16.4 15l1.6 1.6 1.575-1.6L21 16.425 19.4 18l1.6 1.6-1.425 1.4L18 19.425 16.4 21ZM6 19c.283 0 .52-.096.713-.288A.968.968 0 0 0 7 18a.968.968 0 0 0-.287-.712A.967.967 0 0 0 6 17a.967.967 0 0 0-.713.288A.968.968 0 0 0 5 18c0 .283.096.52.287.712.192.192.43.288.713.288Zm0 2a2.893 2.893 0 0 1-2.125-.875A2.893 2.893 0 0 1 3 18c0-.833.292-1.542.875-2.125A2.893 2.893 0 0 1 6 15c.617 0 1.18.17 1.688.512.508.342.879.805 1.112 1.388a2.96 2.96 0 0 0 1.587-1.075A2.922 2.922 0 0 0 11 14v-4c0-1.383.488-2.563 1.463-3.537C13.438 5.487 14.617 5 16 5h1.15l-1.575-1.575L17 2l4 4-4 4-1.425-1.4L17.15 7H16c-.833 0-1.542.292-2.125.875A2.893 2.893 0 0 0 13 10v4a4.823 4.823 0 0 1-1.175 3.212 4.934 4.934 0 0 1-2.975 1.713 2.935 2.935 0 0 1-1.087 1.5A2.917 2.917 0 0 1 6 21ZM4.4 9 3 7.6 4.575 6 3 4.425 4.4 3 6 4.6 7.575 3 9 4.425 7.4 6 9 7.6 7.575 9 6 7.425 4.4 9Z"
            />
        </g>
    </svg>
)
export default TacticIcon
